module.exports = __webpack_public_path__ + "img/logo_wagner_ramos.eb40fa78.png";